'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileoverview
 * TRILL Description モジュールのエントリポイントです。
 */

//------------------------------------------------------------------------------
//
//  Modules
//
//------------------------------------------------------------------------------

var EventEmitter = require('events').EventEmitter;

var _ = require('lodash');

var htmlparser = require('htmlparser2');

var Entities = require('html-entities').AllHtmlEntities;

var domHelper = require('./libs.es/dom-helper');

var trillDescriptionAssets = require('./assets');

//--------------------------------------
//  Debug
//--------------------------------------

var debug = require('debug')('trill-description');

//------------------------------------------------------------------------------
//
//  Constants
//
//------------------------------------------------------------------------------

/**
 * URL のパターン（参考：{@link https://url.spec.whatwg.org/|URL Standard},
 * {@link https://mathiasbynens.be/demo/url-regex|In search of the perfect URL validation regex}）
 *
 * @private
 */
var URL_PATTERN = new RegExp('(http|ftp|https)://[\\w-]+(\\.[\\w-]+)*([\\w.,@?^=%&amp;:/~+#-]*[\\w@?^=%&amp;/~+#-])?');

/**
 * Data URI スキームのパターン
 *
 * @private
 */
var DATA_URI_PATTERN = new RegExp('^data:(.+);base64,(.+)$');

/**
 * DOM 要素の区切り文字（空白）
 *
 * HTML の圧縮処理でインライン要素の必要な空白が除去されるのを防ぐために、
 * ブロック要素は空白で繋ぎます。
 *
 * @private
 */
var DOM_SEPERATOR = ' ';

//------------------------------------------------------------------------------
//
//  Class
//
//------------------------------------------------------------------------------

/**
 * TRILL 仕様に記事本文を分析して出力する TrillDescription クラスです。
 */

var TrillDescription = function (_EventEmitter) {
  _inherits(TrillDescription, _EventEmitter);

  _createClass(TrillDescription, null, [{
    key: 'parse',


    //--------------------------------------
    //  Class methods
    //--------------------------------------

    /**
     * 指定した記事本文を TRILL 仕様に分析して TrillDescription のインスタンスを返します。
     *
     * @param {string} description - 分析する記事本文の文字列（TRILL フィード仕様の HTML 文字列）
     * @param {Object} [options] - TrillDescription インスタンスの初期化オプション
     * @param {boolean} options.ignoreCopyright - 引用や画像、動画などのコンテンツの著作権情報を無視するかどうか
     * @return {Promise} TrillDescription のインスタンスとともに完了したプロミスか、失敗したプロミス
     */
    value: function parse(description, options) {
      var parsePromise = new Promise(function (parseResolve, parseReject) {
        var parserHandler = new htmlparser.DomHandler(function (htmlParseError, doms) {
          if (htmlParseError) {
            debug(htmlParseError);
            return parseReject(htmlParseError);
          }

          try {
            var trillDescription = new TrillDescription(_.defaults({ doms: doms }, options));
            parseResolve(trillDescription);
          } catch (descriptionParseError) {
            parseReject(descriptionParseError);
          }
        }, { normalizeWhitespace: true });

        var parser = new htmlparser.Parser(parserHandler);
        parser.write(description);
        parser.end();
      });

      return parsePromise;
    }

    //--------------------------------------
    //  Constructor
    //--------------------------------------

    /**
     * TrillDescription クラスの新しいインスタンスを初期化します。
     *
     * 記事本文の文字列から初期化する場合は `TrillDescription.parse` を使用します。
     *
     * @param {Object} options - インスタンスの初期化オプション
     * @param {Object} options.doms - 記事本文を構成する DOM の配列（htmlparser2 の DOM オブジェクト）
     * @param {boolean} [options.ignoreCopyright] - 引用や画像、動画などのコンテンツの著作権情報を無視するかどうか
     */

  }]);

  function TrillDescription(options) {
    _classCallCheck(this, TrillDescription);

    /**
     * インスタンスの初期化オプション
     *
     * @type {Object}
     */
    var _this = _possibleConstructorReturn(this, (TrillDescription.__proto__ || Object.getPrototypeOf(TrillDescription)).call(this));

    _this.options = {
      ignoreCopyright: false
    };

    if (options) {
      _.extend(_this.options, options);
    }

    debug('options:', _this.options);

    _this._blockDoms = [];
    _this._inlineDoms = [];

    _this._tables = [];

    _this._articleInternalLinks = [];
    _this._headings = [];
    _this._paragraphs = [];
    _this._lists = [];
    _this._quotations = [];
    _this._imageBlocks = [];
    _this._images = [];
    _this._imageCaptions = [];
    _this._videoBlocks = [];
    _this._videos = [];
    _this._videoCaptions = [];
    _this._youTubeEmbeds = [];
    _this._cgmContentEmbeds = [];
    _this._twitterTweetEmbeds = [];
    _this._twitterTweetEmbedScripts = [];
    _this._facebookPostEmbeds = [];
    _this._facebookPostEmbedScripts = [];
    _this._instagramEmbeds = [];
    _this._instagramEmbedScripts = [];
    _this._pinterestEmbeds = [];
    _this._pinterestEmbedScripts = [];
    _this._blockButtons = [];

    _this._texts = [];
    _this._lineBreaks = [];
    _this._formattings = [];
    _this._links = [];
    _this._buttons = [];

    _this._comments = [];

    _this._warnings = [];

    _this._isSponsoredArticle = false;

    _this._parse();
    return _this;
  }

  //--------------------------------------
  //  Properties
  //--------------------------------------

  /**
   * 記事本文に含まれている、全ての画像 DOM 要素の配列（htmlparser2 の DOM オブジェクト）
   *
   * @type {Array.<Object>}
   */


  _createClass(TrillDescription, [{
    key: 'toString',


    //--------------------------------------
    //  Methods
    //--------------------------------------

    /**
     * 記事本文を平文の文字列で出力します。
     *
     * @return {string}
     */
    value: function toString() {
      var convertedString = '';

      // 出力する前に再度 DOM 要素を分析
      this._parse();

      _.each(this.options.doms, function (dom) {
        convertedString += domHelper.getText(dom);
      });

      // 文字列を圧縮（不要な空白を削除）
      convertedString = convertedString.replace(/\s+/g, ' ').trim();

      debug('to string:');
      debug(convertedString);

      return convertedString;
    }

    /**
     * 記事本文を指定したタイプの HTML 文字列で出力します。
     *
     * - `TRILL_FEED` - TRILL フィード仕様の記事本文
     *   - データベースに保存する記事本文
     *   - SNS 投稿などの埋め込みスクリプトは最適化された状態
     * - `WEB_PART` - TRILL Web 記事詳細画面に表示するの記事本文
     *   - 記事本文のアセット（スタイル・スクリプト）は TRILL Web 側で読み込む
     *   - SNS 投稿などの埋め込みスクリプトは含む
     * - `FULL_PAGE` - TRILL iOS / Android 記事詳細画面（WebView）や TRILL Admin 記事プレビュー画面に表示する記事本文
     *   - 単独で表示できる、DOCTYPE を含む完全な HTML ページ
     *   - 記事本文のアセット（スタイル・スクリプト）を含む
     *   - SNS 投稿などの埋め込みスクリプトも含む
     * - `TINY_MCE` - TRILL Admin 記事本文エディター（TinyMCE）で表示・編集できる記事本文
     *   - 記事本文のスタイルは TRILL Admin 側で読み込む
     *   - 記事本文のスクリプトは含まないので、表示・編集ができる形の HTML で出力（主に画像と動画コンテンツの部分）
     *
     * @param {TrillDescription.HtmlOutputType} [outputType] - 出力タイプ（デフォルトは `TRILL_FEED`）
     * @param {Object} [outputOptions] - 出力オプジョン
     * @param {number} [outputOptions.articleId] - 出力タイプが `WEB_PART` または `FULL_PAGE` の場合、記事の識別 ID
     * @param {number} [outputOptions.excerptParagraphs] - 出力タイプが `WEB_PART` の場合、最初から表示する段落の数（続きを読む機能）
     * @param {string} [outputOptions.articleTitle] - 出力タイプが `FULL_PAGE` の場合、HTML ページのタイトルになる記事のタイトル
     * @param {string} [outputOptions.styleUrl] - 出力タイプが `FULL_PAGE` の場合、記事本文の表示に必要なスタイルの URL（`embedAssets` が `true` の場合は無視される）
     * @param {string} [outputOptions.scriptUrl] - 出力タイプが `FULL_PAGE` の場合、記事本文の表示に必要なスクリプトの URL（`embedAssets` が `true` の場合は無視される）
     * @param {string} [outputOptions.gaPropertyId] - 出力タイプが `FULL_PAGE` の場合、記事本文のトラッキング用 GA プロパティ ID
     * @param {boolean} [outputOptions.embedAssets] - 出力タイプが `FULL_PAGE` の場合、記事本文の表示に必要なアセット（スタイル・スクリプト）を出力する HTML に埋め込むかどうか
     *
     * @return {string}
     */

  }, {
    key: 'toHtmlString',
    value: function toHtmlString() {
      var outputType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : TrillDescription.HtmlOutputType.TRILL_FEED;
      var outputOptions = arguments[1];

      // 出力する前に再度 DOM 要素を分析
      this._parse();

      var outputHtmlString = '';

      if (outputType === TrillDescription.HtmlOutputType.WEB_PART) {
        var dataAttributeString = _.has(outputOptions, 'articleId') ? ' data-article-id="' + outputOptions.articleId + '"' : '';

        if (this._isSponsoredArticle) {
          outputHtmlString = '\n        <div class="trill-description trill-description--sponsored-article"' + dataAttributeString + '>\n          ' + this._convertDomsToString(this.options.doms, outputType) + '\n        </div>\n      ';
        } else if (_.has(outputOptions, 'excerptParagraphs')) {
          // 通常記事の場合、最初から表示する要素と隠して置く要素を出し分ける（TRILL Web モバイル版で使う）
          var visibleDoms = [];
          var hiddenDoms = [];

          var visibleParagraphs = 0;
          _.each(this.options.doms, function (dom) {
            if (visibleParagraphs < outputOptions.excerptParagraphs) {
              if (domHelper.isParagraph(dom)) {
                visibleParagraphs += 1;
              }

              visibleDoms.push(dom);
            } else {
              hiddenDoms.push(dom);
            }
          });

          outputHtmlString = '\n          <div class="trill-description"' + dataAttributeString + '>\n            ' + this._convertDomsToString(visibleDoms, outputType) + '\n          </div>\n\n          <div class="trill-description trill-description--hidden"' + dataAttributeString + '>\n            ' + this._convertDomsToString(hiddenDoms, outputType) + '\n          </div>\n        ';
        } else {
          outputHtmlString = '\n          <div class="trill-description"' + dataAttributeString + '>\n            ' + this._convertDomsToString(this.options.doms, outputType) + '\n          </div>\n        ';
        }
      } else if (outputType === TrillDescription.HtmlOutputType.FULL_PAGE) {
        var titleHtmlString = _.has(outputOptions, 'articleTitle') ? '<title>' + outputOptions.articleTitle + '</title>' : '';

        var _dataAttributeString = _.has(outputOptions, 'articleId') ? ' data-article-id="' + outputOptions.articleId + '"' : '';

        var isEmbedAssets = _.get(outputOptions, 'embedAssets', false);

        var styleHtmlString = !isEmbedAssets && _.has(outputOptions, 'styleUrl') ? '<link rel="stylesheet" href="' + outputOptions.styleUrl + '">' : '<style>' + trillDescriptionAssets.style + '</style>';

        var scriptHtmlString = !isEmbedAssets && _.has(outputOptions, 'scriptUrl') ? '<script src="' + outputOptions.scriptUrl + '"></script>' : '<script>' + trillDescriptionAssets.script + '</script>';

        var gaScriptHtmlString = _.has(outputOptions, 'gaPropertyId') ? '\n        <script async src="https://www.googletagmanager.com/gtag/js?id=' + outputOptions.gaPropertyId + '"></script>\n        <script>\n          window.dataLayer = window.dataLayer || [];\n          function gtag(){dataLayer.push(arguments);}\n          gtag(\'js\', new Date());\n\n          gtag(\'config\', \'' + outputOptions.gaPropertyId + '\', {\n            \'send_page_view\': false,\n            \'custom_map\': {\n              \'dimension2\': \'article_id\',\n              \'dimension9\': \'title\',\n              \'dimension17\': \'link_url\',\n              \'dimension18\': \'link_text\',\n            }\n          });\n        </script>\n      ' : '';

        var descriptionHtmlString = this._convertDomsToString(this.options.doms, outputType);

        outputHtmlString = '\n        <!doctype html>\n        <html lang="ja">\n          <head>\n            <meta charset="utf-8">\n            <meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no">\n            ' + titleHtmlString + '\n            ' + styleHtmlString + '\n          </head>\n\n          <body class="trill-description' + (this._isSponsoredArticle ? ' trill-description--sponsored-article' : '') + '"' + _dataAttributeString + '>\n            ' + this._appendSnsEmbedScript(descriptionHtmlString) + '\n            ' + gaScriptHtmlString + '\n            ' + scriptHtmlString + '\n          </body>\n        </html>\n      ';
      } else if (outputType === TrillDescription.HtmlOutputType.TINY_MCE) {
        outputHtmlString = this._convertDomsToString(this.options.doms, outputType);
      } else {
        // その他（デフォルトの `TRILL_FEED`）
        var _descriptionHtmlString = this._convertDomsToString(this.options.doms, outputType);
        outputHtmlString = this._appendSnsEmbedScript(_descriptionHtmlString);
      }

      // HTML 文字列を圧縮
      outputHtmlString = outputHtmlString.replace(/\s+/g, ' ').trim();

      debug('to html string:');
      debug(outputHtmlString);

      return outputHtmlString;
    }

    //--------------------------------------
    //  Private methods
    //--------------------------------------

    /**
     * DOM 要素を TRILL 仕様に分析します。
     *
     * @private
     */

  }, {
    key: '_parse',
    value: function _parse() {
      var _this2 = this;

      // 記事本文の DOM 要素を TRILL 仕様に分析
      _.each(this.options.doms, function (dom) {
        _this2._parseBlockDom(dom);
      });

      if (_.isEmpty(this._blockDoms)) {
        var error = new Error('Empty doms');
        debug(error);
        throw error;
      }
    }

    /**
     * ブロックの DOM 要素を TRILL 仕様に分析します。
     *
     * @param {Object} dom - htmlparser2 の DOM オブジェクト
     * @private
     */

  }, {
    key: '_parseBlockDom',
    value: function _parseBlockDom(dom) {
      var _this3 = this;

      debug('parse block dom: %O', dom);

      if (domHelper.isEmptyDom(dom)) {
        // 空のブロック DOM 要素は無視
        return;
      }

      if (domHelper.isLineBreak(dom)) {
        // ブロック DOM 要素間の改行は無視
        return;
      }

      if (domHelper.isTable(dom)) {
        this._tables.push(dom);
      } else if (domHelper.isArticleInternalLink(dom)) {
        this._articleInternalLinks.push(dom);
      } else if (domHelper.isHeading(dom)) {
        var isDomAttribsClassHeading = dom.attribs.class && dom.attribs.class.match(/heading/gi);
        if (!isDomAttribsClassHeading) {
          dom.attribs.class = 'heading';
        }

        this._headings.push(dom);
      } else if (domHelper.isParagraph(dom)) {
        _.each(dom.children, function (childDom) {
          _this3._parseInlineDom(childDom);
        });

        this._paragraphs.push(dom);
      } else if (domHelper.isList(dom)) {
        this._lists.push(dom);
      } else if (domHelper.isQuotation(dom)) {
        var citeDom = domHelper.findChildDomByTag(dom, 'cite');

        // 引用元の情報を確認
        if (_.isNil(citeDom)) {
          if (!this.options.ignoreCopyright) {
            var warning = 'Missing required cite for quotation: "' + domHelper.getText(dom).trim() + '"';
            this._addWarning(warning);
          }
        } else {
          _.each(citeDom.children, function (citeChildDom) {
            if (domHelper.isLink(citeChildDom)) {
              // 引用元の URL を確認（書籍など引用元の URL が存在しない場合は除く）

              var citeLinkUrl = citeChildDom.attribs.href;
              var citeLinkText = domHelper.getText(citeChildDom);

              if (_.isNil(citeLinkUrl) || !URL_PATTERN.test(citeLinkUrl) || !citeLinkText) {
                var error = new Error('Invalid cite link: ' + JSON.stringify({
                  text: citeLinkText,
                  url: citeLinkUrl
                }));

                debug(error);
                throw error;
              }
            }
          });
        }

        this._quotations.push(dom);
      } else if (domHelper.isImageBlock(dom)) {
        var imageDom = domHelper.findChildDomByTag(dom, 'img');
        var captionDom = domHelper.findChildDomByTag(dom, 'figcaption');

        // 画像の URL を確認
        if (_.isNil(imageDom.attribs.src) || !(URL_PATTERN.test(imageDom.attribs.src) || DATA_URI_PATTERN.test(imageDom.attribs.src))) {
          var error = new Error('Invalid image source: "' + imageDom.attribs.src + '"');
          debug(error);
          throw error;
        }

        // 画像の表示サイズを確認
        if (_.isNil(imageDom.attribs.width) || _.isNil(imageDom.attribs.height)) {
          var _error = new Error('Invalid image display size: ' + JSON.stringify({
            width: imageDom.attribs.width,
            height: imageDom.attribs.height
          }));
          debug(_error);
          throw _error;
        }

        // 出典元の情報（または画像の説明）を確認
        if (_.isNil(captionDom)) {
          if (!this.options.ignoreCopyright) {
            var _warning = 'Missing required caption for image: ' + JSON.stringify({
              src: imageDom.attribs.src,
              alt: imageDom.attribs.alt
            });

            this._addWarning(_warning);
          }
        } else {
          _.each(captionDom.children, function (captionChildDom) {
            if (domHelper.isLink(captionChildDom)) {
              // 出典元の URL を確認（引用画像ではない、または出典元の URL が存在しない場合は除く）

              var captionLinkUrl = captionChildDom.attribs.href;
              var captionLinkText = domHelper.getText(captionChildDom);

              if (_.isNil(captionLinkUrl) || !URL_PATTERN.test(captionLinkUrl) || !captionLinkText) {
                var _error2 = new Error('Invalid caption link: ' + JSON.stringify({
                  text: captionLinkText,
                  url: captionLinkUrl
                }));
                debug(_error2);
                throw _error2;
              }
            }
          });

          this._imageCaptions.push(captionDom);
        }

        this._imageBlocks.push(dom);
        this._images.push(imageDom);
      } else if (domHelper.isVideoBlock(dom)) {
        var videoDom = domHelper.findChildDomByTag(dom, 'video');
        var videoSourceDoms = domHelper.findChildDomsByTag(videoDom, 'source');
        var videoSources = [];
        var _captionDom = domHelper.findChildDomByTag(dom, 'figcaption');

        // 動画のソース URL を確認（MP4 フォーマットは必須）
        var hasMp4 = false;
        _.each(videoSourceDoms, function (videoSourceDom) {
          if (_.isNil(videoSourceDom.attribs.src) || !(URL_PATTERN.test(videoSourceDom.attribs.src) || DATA_URI_PATTERN.test(videoSourceDom.attribs.src))) {
            var _error3 = new Error('Invalid video source: ' + JSON.stringify({
              src: videoSourceDom.attribs.src,
              type: videoSourceDom.attribs.type
            }));
            debug(_error3);
            throw _error3;
          }

          if (videoSourceDom.attribs.type === 'video/mp4') {
            hasMp4 = true;
          }

          videoSources.push({
            src: videoSourceDom.attribs.src,
            type: videoSourceDom.attribs.type
          });
        });

        if (!hasMp4) {
          var _error4 = new Error('Mission required video source for MP4 format: ' + JSON.stringify(videoSources));
          debug(_error4);
          throw _error4;
        }

        // 動画の表示サイズを確認
        if (_.isNil(videoDom.attribs.width) || _.isNil(videoDom.attribs.height)) {
          var _error5 = new Error('Invalid video display size: ' + JSON.stringify({
            width: videoDom.attribs.width,
            height: videoDom.attribs.height
          }));
          debug(_error5);
          throw _error5;
        }

        // 出典元の情報（または動画の説明）を確認
        if (_.isNil(_captionDom)) {
          if (!this.options.ignoreCopyright) {
            var _warning2 = 'Missing required caption for video: ' + JSON.stringify(videoSources);
            this._addWarning(_warning2);
          }
        } else {
          _.each(_captionDom.children, function (captionChildDom) {
            if (domHelper.isLink(captionChildDom)) {
              // 出典元の URL を確認（引用動画ではない、または出典元の URL が存在しない場合は除く）

              var captionLinkUrl = captionChildDom.attribs.href;
              var captionLinkText = domHelper.getText(captionChildDom);

              if (_.isNil(captionLinkUrl) || !URL_PATTERN.test(captionLinkUrl) || !captionLinkText) {
                var _error6 = new Error('Invalid caption link: ' + JSON.stringify({
                  text: captionLinkText,
                  url: captionLinkUrl
                }));
                debug(_error6);
                throw _error6;
              }
            }
          });

          this._videoCaptions.push(_captionDom);
        }

        this._videoBlocks.push(dom);
        this._videos.push(videoDom);
      } else if (domHelper.isYouTubeEmbed(dom)) {
        var youtubeEmbedDom = dom.name === 'iframe' ? dom : domHelper.findChildDomByTag(dom, 'iframe');
        this._youTubeEmbeds.push(youtubeEmbedDom);
      } else if (domHelper.isCgmContentEmbed(dom)) {
        this._cgmContentEmbeds.push(dom);
      } else if (domHelper.isTwitterTweetEmbed(dom)) {
        // TODO: Twitter 埋め込みツイートの URL が有効かどうか確認
        this._twitterTweetEmbeds.push(dom);
      } else if (domHelper.isFacebookPostEmbed(dom)) {
        // TODO: Facebook 埋め込み投稿の URL が有効かどうか確認
        this._facebookPostEmbeds.push(dom);
      } else if (domHelper.isInstagramEmbed(dom)) {
        // TODO: Instagram 埋め込みの URL が有効かどうか確認
        this._instagramEmbeds.push(dom);
      } else if (domHelper.isPinterestEmbed(dom)) {
        // TODO: Pinterest 埋め込みの URL が有効かどうか確認
        this._pinterestEmbeds.push(dom);
      } else if (domHelper.isComment(dom)) {
        this._comments.push(dom);
      } else if (domHelper.isTwitterTweetEmbedScript(dom)) {
        this._twitterTweetEmbedScripts.push(dom);
      } else if (domHelper.isFacebookPostEmbedScript(dom)) {
        this._facebookPostEmbedScripts.push(dom);
      } else if (domHelper.isInstagramEmbedScript(dom)) {
        this._instagramEmbedScripts.push(dom);
      } else if (domHelper.isPinterestEmbedScript(dom)) {
        this._pinterestEmbedScripts.push(dom);
      } else if (domHelper.isBlockButton(dom)) {
        this._blockButtons.push(dom);
      } else {
        var _error7 = new Error('Invalid block dom detected: ' + JSON.stringify({
          type: dom.type,
          name: dom.name,
          data: dom.data,
          attribs: dom.attribs
        }));
        debug(_error7);
        throw _error7;
      }

      this._blockDoms.push(dom);
    }

    /**
     * インラインの DOM 要素を TRILL 仕様に分析します。
     *
     * @param {Object} dom - htmlparser2 の DOM オブジェクト
     * @private
     */

  }, {
    key: '_parseInlineDom',
    value: function _parseInlineDom(dom) {
      var _this4 = this;

      debug('parse inline dom: %O', dom);

      if (domHelper.isText(dom)) {
        this._texts.push(dom);
      } else if (domHelper.isLineBreak(dom)) {
        this._lineBreaks.push(dom);
      } else if (domHelper.isFormatting(dom)) {
        this._formattings.push(dom);

        _.each(dom.children, function (childDom) {
          _this4._parseInlineDom(childDom);
        });
      } else if (domHelper.isLink(dom)) {
        var linkUrl = dom.attribs.href;
        var linkText = domHelper.getText(dom);

        if (_.isNil(linkUrl) || !URL_PATTERN.test(linkUrl) || !linkText) {
          var error = new Error('Invalid link: ' + JSON.stringify({
            text: linkText,
            url: linkUrl
          }));
          debug(error);
          throw error;
        }

        this._links.push(dom);

        _.each(dom.children, function (childDom) {
          _this4._parseInlineDom(childDom);
        });
      } else if (domHelper.isComment(dom)) {
        this._comments.push(dom);
      } else if (domHelper.isTwitterTweetEmbedScript(dom)) {
        this._twitterTweetEmbedScripts.push(dom);
      } else if (domHelper.isFacebookPostEmbedScript(dom)) {
        this._facebookPostEmbedScripts.push(dom);
      } else if (domHelper.isInstagramEmbedScript(dom)) {
        this._instagramEmbedScripts.push(dom);
      } else if (domHelper.isPinterestEmbedScript(dom)) {
        this._pinterestEmbedScripts.push(dom);
      } else if (domHelper.isButton(dom)) {
        if (dom.name === 'a') {
          var linkButtonUrl = dom.attribs.href;
          var linkButtonText = domHelper.getText(dom);

          if (_.isNil(linkButtonUrl) || !URL_PATTERN.test(linkButtonUrl) || !linkButtonText) {
            var _error8 = new Error('Invalid link button: ' + JSON.stringify({
              text: linkButtonText,
              url: linkButtonUrl
            }));
            debug(_error8);
            throw _error8;
          }
        }

        this._buttons.push(dom);
      } else {
        var _error9 = new Error('Invalid inline dom detected: ' + JSON.stringify({
          type: dom.type,
          name: dom.name,
          data: dom.data,
          attribs: dom.attribs
        }));
        debug(_error9);
        throw _error9;
      }

      this._inlineDoms.push(dom);
    }

    /**
     * 全ての DOM 要素を TRILL 仕様の文字列に変換します。
     *
     * @param {Object} doms - htmlparser2 の DOM オブジェクト
     * @param {TrillDescription.HtmlOutputType} [outputType] - 出力タイプ（デフォルトは `TRILL_FEED`）
     * @private
     */

  }, {
    key: '_convertDomsToString',
    value: function _convertDomsToString(doms) {
      var _this5 = this;

      var outputType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : TrillDescription.HtmlOutputType.TRILL_FEED;

      var domString = '';

      _.each(doms, function (dom) {
        domString += _this5._convertBlockDomToString(dom, outputType);
      });

      return domString;
    }

    /**
     * ブロックの DOM 要素を TRILL 仕様の文字列に変換します。
     *
     * @param {Object} dom - htmlparser2 の DOM オブジェクト
     * @param {TrillDescription.HtmlOutputType} [outputType] - 出力タイプ（デフォルトは `TRILL_FEED`）
     * @private
     */

  }, {
    key: '_convertBlockDomToString',
    value: function _convertBlockDomToString(dom) {
      var _this6 = this;

      var outputType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : TrillDescription.HtmlOutputType.TRILL_FEED;

      debug('convert block dom: %O', dom);

      if (domHelper.isEmptyDom(dom) || domHelper.isComment(dom)) {
        // コメント、または空の DOM 要素は何もしない
        debug('converted block dom string: (empty)');
        return '';
      }

      var domString = '';

      if (domHelper.isTable(dom)) {
        domString += htmlparser.DomUtils.getInnerHTML({ children: [dom] });
      } else if (domHelper.isArticleInternalLink(dom)) {
        domString += htmlparser.DomUtils.getInnerHTML({ children: [dom] });
      } else if (domHelper.isHeading(dom)) {
        if (dom.name === 'hr') {
          domString += '<hr>';
        } else {
          domString += '<' + dom.name + ' class="' + dom.attribs.class + '">' + domHelper.getText(dom) + '</' + dom.name + '>';
        }
      } else if (domHelper.isParagraph(dom)) {
        var childDomString = '';

        _.each(dom.children, function (childDom) {
          childDomString += _this6._convertInlineDomToString(childDom);
        });

        if (childDomString.trim()) {
          // 中身が空の段落は出力しない
          domString += '<' + dom.name + '>' + childDomString + '</' + dom.name + '>';
        }
      } else if (domHelper.isList(dom)) {
        domString += '<' + dom.name + '>';
        domString += DOM_SEPERATOR;

        _.each(dom.children, function (childDom) {
          if (childDom.name === 'li') {
            domString += '<li>';

            _.each(childDom.children, function (listItemChildDom) {
              domString += _this6._convertInlineDomToString(listItemChildDom);
            });

            domString += '</li>';
            domString += DOM_SEPERATOR;
          }
        });

        domString += '</' + dom.name + '>';
      } else if (domHelper.isQuotation(dom)) {
        domString += '<blockquote>';
        domString += DOM_SEPERATOR;

        _.each(dom.children, function (childDom) {
          if (childDom.name === 'cite') {
            var citeDomString = '';
            _.each(childDom.children, function (citeChildDom) {
              if (domHelper.isText(citeChildDom)) {
                citeDomString += domHelper.getText(citeChildDom);
              } else if (domHelper.isLink(citeChildDom)) {
                citeDomString += '<a href="' + citeChildDom.attribs.href + '">' + domHelper.getText(citeChildDom) + '</a>';
              }
            });

            domString += '<cite>' + citeDomString + '</cite>';
          } else {
            domString += _this6._convertInlineDomToString(childDom);
          }
        });

        domString += '</blockquote>';
      } else if (domHelper.isImageBlock(dom)) {
        var imageDom = domHelper.findChildDomByTag(dom, 'img');
        var captionDom = domHelper.findChildDomByTag(dom, 'figcaption');

        var captionDomString = '';
        if (!_.isNil(captionDom)) {
          _.each(captionDom.children, function (captionChildDom) {
            if (domHelper.isText(captionChildDom)) {
              captionDomString += domHelper.getText(captionChildDom);
            } else if (domHelper.isLink(captionChildDom)) {
              captionDomString += '<a href="' + captionChildDom.attribs.href + '">' + domHelper.getText(captionChildDom) + '</a>';
            }
          });

          switch (outputType) {// eslint-disable-line default-case
            case TrillDescription.HtmlOutputType.TRILL_FEED:
              captionDomString = '<figcaption>' + captionDomString + '</figcaption>';
              break;
            case TrillDescription.HtmlOutputType.WEB_PART:
            case TrillDescription.HtmlOutputType.FULL_PAGE:
              captionDomString = '<figcaption class="image-block__caption">' + captionDomString + '</figcaption>';
              break;
            case TrillDescription.HtmlOutputType.TINY_MCE:
              captionDomString = '<figcaption contenteditable="true">' + captionDomString + '</figcaption>';
              break;
          }
        }

        var imageWidth = parseFloat(imageDom.attribs.width);
        var imageHeight = parseFloat(imageDom.attribs.height);

        // 横縦比のパーセンテージ（小数点以下２桁まで）
        var imageAspectRatioPercent = Math.round(imageHeight / imageWidth * 10000) / 100;

        switch (outputType) {// eslint-disable-line default-case
          case TrillDescription.HtmlOutputType.TRILL_FEED:
            domString += '\n            <figure>\n              <img src="' + imageDom.attribs.src + '"\n                   alt="' + imageDom.attribs.alt + '"\n                   width="' + imageWidth + '" height="' + imageHeight + '">\n              ' + captionDomString + '\n            </figure>\n          ';
            break;
          case TrillDescription.HtmlOutputType.WEB_PART:
          case TrillDescription.HtmlOutputType.FULL_PAGE:
            domString += '\n            <figure class="image-block">\n              <div class="image-block__column" style="width: ' + imageWidth + 'px;">\n                <div class="image-block__row" style="padding-top: ' + imageAspectRatioPercent + '%;">\n                  <img class="image-block__image"\n                      data-src="' + imageDom.attribs.src + '"\n                      alt="' + imageDom.attribs.alt + '">\n                </div>\n              ' + captionDomString + '\n              </div>\n            </figure>\n          ';
            break;
          case TrillDescription.HtmlOutputType.TINY_MCE:
            if (_.isEmpty(captionDomString)) {
              domString += '\n              <p>\n                <img src="' + imageDom.attribs.src + '"\n                     alt="' + imageDom.attribs.alt + '"\n                     width="' + imageWidth + '" height="' + imageHeight + '"\n                     contenteditable="true">\n              </p>\n            ';
            } else {
              domString += '\n              <figure class="image" contenteditable="false">\n                <img src="' + imageDom.attribs.src + '"\n                    alt="' + imageDom.attribs.alt + '"\n                    width="' + imageWidth + '" height="' + imageHeight + '"\n                    contenteditable="true">\n                ' + captionDomString + '\n              </figure>\n            ';
            }
            break;
        }
      } else if (domHelper.isVideoBlock(dom)) {
        var videoDom = domHelper.findChildDomByTag(dom, 'video');
        var videoSourceDoms = domHelper.findChildDomsByTag(videoDom, 'source');
        var _captionDom2 = domHelper.findChildDomByTag(dom, 'figcaption');

        var videoSourceDomsString = '';
        _.each(videoSourceDoms, function (videoSourceDom) {
          videoSourceDomsString += '<source src="' + videoSourceDom.attribs.src + '" type="' + videoSourceDom.attribs.type + '">';
          videoSourceDomsString += DOM_SEPERATOR;
        });

        var _captionDomString = '';
        if (!_.isNil(_captionDom2)) {
          _.each(_captionDom2.children, function (captionChildDom) {
            if (domHelper.isText(captionChildDom)) {
              _captionDomString += domHelper.getText(captionChildDom);
            } else if (domHelper.isLink(captionChildDom)) {
              _captionDomString += '<a href="' + captionChildDom.attribs.href + '">' + domHelper.getText(captionChildDom) + '</a>';
            }
          });

          switch (outputType) {// eslint-disable-line default-case
            case TrillDescription.HtmlOutputType.TRILL_FEED:
              _captionDomString = '<figcaption>' + _captionDomString + '</figcaption>';
              break;
            case TrillDescription.HtmlOutputType.WEB_PART:
            case TrillDescription.HtmlOutputType.FULL_PAGE:
              _captionDomString = '<figcaption class="video-block__caption">' + _captionDomString + '</figcaption>';
              break;
            case TrillDescription.HtmlOutputType.TINY_MCE:
              // TODO: TinyMCE で表示・編集ができる形の HTML で出力（`contenteditable` 属性の設定など）
              break;
          }
        }

        var videoWidth = parseFloat(videoDom.attribs.width);
        var videoHeight = parseFloat(videoDom.attribs.height);

        // 横縦比のパーセンテージ（小数点以下２桁まで）
        var videoAspectRatioPercent = Math.round(videoHeight / videoWidth * 10000) / 100;

        switch (outputType) {// eslint-disable-line default-case
          case TrillDescription.HtmlOutputType.TRILL_FEED:
            domString += '\n            <figure>\n              <video width="' + videoWidth + '" height="' + videoHeight + '">\n                ' + videoSourceDomsString + '\n              </video>\n              ' + _captionDomString + '\n            </figure>\n          ';
            break;
          case TrillDescription.HtmlOutputType.WEB_PART:
          case TrillDescription.HtmlOutputType.FULL_PAGE:
            domString += '\n            <figure class="video-block">\n              <div class="video-block__column" style="width: ' + videoWidth + 'px;">\n                <div class="video-block__row" style="padding-top: ' + videoAspectRatioPercent + '%;">\n                  <video class="video-block__video" controls>\n                    ' + videoSourceDomsString + '\n                  </video>\n                </div>\n              ' + _captionDomString + '\n              </div>\n            </figure>\n          ';
            break;
          case TrillDescription.HtmlOutputType.TINY_MCE:
            // TODO: TinyMCE で表示・編集ができる形の HTML で出力（`contenteditable` 属性の設定など）
            break;
        }
      } else if (domHelper.isYouTubeEmbed(dom) || domHelper.isCgmContentEmbed(dom)) {
        var iframe = dom.name === 'iframe' ? dom : domHelper.findChildDomByTag(dom, 'iframe');
        var videoSource = iframe.attribs.src;
        var _videoWidth = parseFloat(iframe.attribs.width);
        var _videoHeight = parseFloat(iframe.attribs.height);

        // 横縦比のパーセンテージ（小数点以下２桁まで）
        var _videoAspectRatioPercent = Math.round(_videoHeight / _videoWidth * 10000) / 100;

        switch (outputType) {// eslint-disable-line default-case
          case TrillDescription.HtmlOutputType.TRILL_FEED:
            domString += '\n            <iframe src="' + videoSource + '"\n                    width="' + _videoWidth + '" height="' + _videoHeight + '"\n                    frameborder="0" allowfullscreen>\n            </iframe>\n          ';
            break;
          case TrillDescription.HtmlOutputType.WEB_PART:
          case TrillDescription.HtmlOutputType.FULL_PAGE:
            domString += '\n            <div class="video-block">\n              <div class="video-block__column" style="width: ' + _videoWidth + 'px;">\n                <div class="video-block__row" style="padding-top: ' + _videoAspectRatioPercent + '%;">\n                  <iframe class="video-block__video"\n                          src="' + videoSource + '"\n                          width="' + _videoWidth + '" height="' + _videoHeight + '"\n                          frameborder="0" allowfullscreen>\n                  </iframe>\n                </div>\n              </div>\n            </div>\n          ';
            break;
          case TrillDescription.HtmlOutputType.TINY_MCE:
            domString += '\n            <p>\n              <span class="mce-preview-object mce-object-iframe"\n                    contenteditable="false" data-mce-object="iframe"\n                    data-mce-p-allowfullscreen="allowfullscreen"\n                    data-mce-p-src="' + videoSource + '">\n                    <iframe src="' + videoSource + '"\n                            width="' + _videoWidth + '" height="' + _videoHeight + '" frameborder="0"\n                            allowfullscreen="allowfullscreen">\n                    </iframe>\n                    <span class="mce-shim"></span>\n              </span>\n            </p>\n          ';
            break;
        }
      } else if (domHelper.isTwitterTweetEmbed(dom)) {
        if (_.isEqual(outputType, TrillDescription.HtmlOutputType.TINY_MCE)) {
          if (dom.name === 'blockquote') {
            // TinyMCE で blockquote の場合は、編集が出来る形にして出力
            var embedDom = this._appendTwitterTweetEmbedScript(htmlparser.DomUtils.getInnerHTML({ children: [dom] }));
            domString += '\n            <p contenteditable="false">\n              <iframe width="100%"\n                      src="javascript: \'' + embedDom.replace(/"/g, '&quot;') + '\'"\n                      style="border: none">\n              </iframe>\n            </p>\n          ';
          } else {
            // TinyMCE で iframe の場合はそのまま出力
            domString += htmlparser.DomUtils.getInnerHTML({ children: [dom] });
          }
        } else if (dom.name === 'blockquote') {
          // TinyMCE 以外の場合で blockquote の埋め込みコードはそのまま出力
          domString += htmlparser.DomUtils.getInnerHTML({ children: [dom] });
        } else {
          // TinyMCE 以外の場合で iframe の埋め込みコードは src の要素のみを抜き出して decode してから出力
          var entities = new Entities();
          var twitterEmbedMatch = _.get(domHelper.findChildDomByTag(dom, 'iframe'), 'attribs.src').match(/^javascript:\s?'([\s\S]*)?'/);
          domString += entities.decode(twitterEmbedMatch[1]);
        }
      } else if (domHelper.isFacebookPostEmbed(dom)) {
        if (_.isEqual(outputType, TrillDescription.HtmlOutputType.TINY_MCE)) {
          if (dom.name === 'p' && !_.isNil(domHelper.findChildDomByTag(dom, 'iframe'))) {
            // TinyMCE で 編集できる iframe の場合 (p タグの中に iframe) はそのまま出力
            domString += htmlparser.DomUtils.getInnerHTML({ children: [dom] });
          } else if (dom.name === 'iframe') {
            // TinyMCE で iframe のみの場合 Javascript SDK 形式に変更して TinyMCE で変種できるかたちで出力
            var hrefMatch = dom.attribs.src.match(/href=(.+?)&/);
            var _embedDom = '<div class="fb-post" data-href="' + decodeURIComponent(hrefMatch[1]) + '"> </div>';
            domString += '\n            <p contenteditable="false">\n              <iframe width="100%"\n                      src="javascript: \'' + _embedDom.replace(/"/g, '&quot;').trim() + '\'"\n                      style="border: none">\n              </iframe>\n            </p>\n          ';
          } else {
            // TinyMCE で Javascript SDK 形式に変更の場合は TinyMCE で編集できるかたちで出力
            var _embedDom2 = this._appendFacebookPostEmbedScript(htmlparser.DomUtils.getInnerHTML({ children: [dom] }));
            domString += '\n            <p contenteditable="false">\n              <iframe width="100%"\n                      src="javascript: \'' + _embedDom2.replace(/"/g, '&quot;').trim() + '\'"\n                      style="border: none">\n              </iframe>\n            </p>\n          ';
          }
        } else if (dom.name === 'p' && !_.isNil(domHelper.findChildDomByTag(dom, 'iframe'))) {
          // TinyMCE 以外の場合で p タグに wrap された iframe の埋め込みコードは src の要素のみを抜き出して decode してから出力
          var _entities = new Entities();
          var facebookPostEmbedMatch = _.get(domHelper.findChildDomByTag(dom, 'iframe'), 'attribs.src').match(/^javascript:\s?'(.[\s\S]*)?'/);
          domString += _entities.decode(facebookPostEmbedMatch[1]);
        } else if (dom.name === 'iframe') {
          // iframe 形式は Javascript SDK 形式に変更
          var _hrefMatch = dom.attribs.src.match(/href=(.+?)&/);
          domString += '<div class="fb-post" data-href="' + decodeURIComponent(_hrefMatch[1]) + '"> </div>';
        } else {
          // 埋め込みコードはそのまま出力
          domString += htmlparser.DomUtils.getInnerHTML({ children: [dom] });
        }
      } else if (domHelper.isInstagramEmbed(dom)) {
        if (_.isEqual(outputType, TrillDescription.HtmlOutputType.TINY_MCE)) {
          if (dom.name === 'blockquote') {
            // TinyMCE で blockquote の場合は、編集が出来る形にして出力
            var _embedDom3 = this._appendInstagramEmbedScript(htmlparser.DomUtils.getInnerHTML({ children: [dom] }));
            domString += '\n            <p contenteditable="false">\n              <iframe width="100%"\n                      src="javascript: \'' + _embedDom3.replace(/"/g, '&quot;') + '\'"\n                      style="border: none">\n              </iframe>\n            </p>\n          ';
          } else {
            // TinyMCE で iframe の場合はそのまま出力
            domString += htmlparser.DomUtils.getInnerHTML({ children: [dom] });
          }
        } else if (dom.name === 'blockquote') {
          // TinyMCE 以外の場合で blockquote の埋め込みコードはそのまま出力
          domString += htmlparser.DomUtils.getInnerHTML({ children: [dom] });
        } else {
          // TinyMCE 以外の場合で iframe の埋め込みコードは src の要素のみを抜き出して decode してから出力
          var _entities2 = new Entities();
          var instagramEmbedMatch = _.get(domHelper.findChildDomByTag(dom, 'iframe'), 'attribs.src').match(/^javascript:\s?'([\s\S]*)?'/);
          domString += _entities2.decode(instagramEmbedMatch[1]);
        }
      } else if (domHelper.isPinterestEmbed(dom)) {
        if (_.isEqual(outputType, TrillDescription.HtmlOutputType.TINY_MCE)) {
          if (dom.name === 'a') {
            // TinyMCE で a タグ の場合は、編集が出来る形にして出力
            var _embedDom4 = this._appendPinterestEmbedScript(htmlparser.DomUtils.getInnerHTML({ children: [dom] }));
            domString += '\n            <p contenteditable="false">\n              <iframe width="100%"\n                      src="javascript: \'' + _embedDom4.replace(/"/g, '&quot;') + '\'"\n                      style="border: none">\n              </iframe>\n            </p>\n          ';
          } else {
            // TinyMCE で iframe の場合はそのまま出力
            domString += htmlparser.DomUtils.getInnerHTML({ children: [dom] });
          }
        } else if (dom.name === 'a') {
          // TinyMCE 以外の場合で a タグの埋め込みコードはそのまま出力
          domString += htmlparser.DomUtils.getInnerHTML({ children: [dom] });
        } else {
          // TinyMCE 以外の場合で iframe の埋め込みコードは src の要素のみを抜き出して decode してから出力
          var _entities3 = new Entities();
          var pinterestEmbedMatch = _.get(domHelper.findChildDomByTag(dom, 'iframe'), 'attribs.src').match(/^javascript:\s?'([\s\S]*)?'/);
          domString += _entities3.decode(pinterestEmbedMatch[1]);
        }
      } else if (domHelper.isBlockButton(dom)) {
        var blockButton = dom.name === 'p' ? domHelper.findChildDomByTag(dom, 'a') : dom;
        if (_.isEqual(outputType, TrillDescription.HtmlOutputType.TINY_MCE)) {
          // TinyMCE の場合 p タグで囲まないと a タグが連続した場合に全ての a タグが一括で p タグに囲まれてしまいバグるためタグを p タグで囲んで出力
          if (blockButton.name === 'a') {
            domString += '<p><a class="' + blockButton.attribs.class + '" href="' + blockButton.attribs.href + '">' + domHelper.getText(blockButton) + '</a></p>';
          } else if (blockButton.name === 'button') {
            if (_.has(blockButton.attribs, 'disabled')) {
              domString += '<p><button class="' + blockButton.attribs.class + '" disabled>' + domHelper.getText(blockButton) + '</button></p>';
            } else {
              domString += '<p><button class="' + blockButton.attribs.class + '">' + domHelper.getText(blockButton) + '</button></p>';
            }
          }
        } else if (blockButton.name === 'a') {
          domString += '<a class="' + blockButton.attribs.class + '" href="' + blockButton.attribs.href + '">' + domHelper.getText(blockButton) + '</a>';
        } else if (blockButton.name === 'button') {
          if (_.has(blockButton.attribs, 'disabled')) {
            domString += '<button class="' + blockButton.attribs.class + '" disabled>' + domHelper.getText(blockButton) + '</button>';
          } else {
            domString += '<button class="' + blockButton.attribs.class + '">' + domHelper.getText(blockButton) + '</button>';
          }
        }
      }

      domString += DOM_SEPERATOR;

      debug('converted block dom string: "%s"', domString);

      return domString;
    }

    /**
     * インラインの DOM 要素を TRILL 仕様の文字列に変換します。
     *
     * @param {Object} dom - htmlparser2 の DOM オブジェクト
     * @private
     */

  }, {
    key: '_convertInlineDomToString',
    value: function _convertInlineDomToString(dom) {
      var _this7 = this;

      debug('convert inline dom: %O', dom);

      if (domHelper.isComment(dom)) {
        // コメントは何もしない
        debug('converted inline dom string: (empty)');
        return '';
      }

      var domString = '';

      if (domHelper.isText(dom)) {
        domString += domHelper.getText(dom);
      } else if (domHelper.isLineBreak(dom)) {
        domString += '<br>';
      } else if (domHelper.isFormatting(dom)) {
        var childDomString = '';

        _.each(dom.children, function (childDom) {
          childDomString += _this7._convertInlineDomToString(childDom);
        });

        if (childDomString) {
          domString += '<' + dom.name + '>' + childDomString + '</' + dom.name + '>';
        }
      } else if (domHelper.isLink(dom)) {
        var _childDomString = '';

        _.each(dom.children, function (childDom) {
          _childDomString += _this7._convertInlineDomToString(childDom);
        });

        if (_childDomString) {
          domString += '<a href="' + dom.attribs.href + '">' + _childDomString + '</a>';
        } else {
          domString += '';
        }
      } else if (domHelper.isButton(dom)) {
        if (dom.name === 'a') {
          domString += '<a class="' + dom.attribs.class + '" href="' + dom.attribs.href + '">' + domHelper.getText(dom) + '</a>';
        } else if (dom.name === 'button') {
          if (_.has(dom.attribs, 'disabled')) {
            domString += '<button class="' + dom.attribs.class + '" disabled>' + domHelper.getText(dom) + '</button>';
          } else {
            domString += '<button class="' + dom.attribs.class + '">' + domHelper.getText(dom) + '</button>';
          }
        }
      }

      debug('converted inline dom string: "%s"', domString);

      return domString;
    }

    /**
     * SNS 埋め込みスクリプトを追加した HTML 文字列を返します。
     *
     * @param {string} inputHtmlString - SNS 埋め込みスクリプトを追加する、対象の HTML 文字列
     * @private
     */

  }, {
    key: '_appendSnsEmbedScript',
    value: function _appendSnsEmbedScript(inputHtmlString) {
      var outputHtmlString = inputHtmlString;

      // Twitter 埋め込みツイートの JavaScript は本文の最後に１回出力
      if (!_.isEmpty(this._twitterTweetEmbedScripts)) {
        outputHtmlString = this._appendTwitterTweetEmbedScript(outputHtmlString);
      }

      // Facebook 埋め込み投稿の JavaScript は本文の最初に１回出力
      if (!_.isEmpty(this._facebookPostEmbedScripts)) {
        outputHtmlString = this._appendFacebookPostEmbedScript(outputHtmlString);
      }

      // Instagram 埋め込みの JavaScript は本文の最後に１回出力
      if (!_.isEmpty(this._instagramEmbedScripts)) {
        outputHtmlString = this._appendInstagramEmbedScript(outputHtmlString);
      }

      // Pinterest 埋め込みの JavaScript は本文の最後に１回出力
      if (!_.isEmpty(this._pinterestEmbedScripts)) {
        outputHtmlString = this._appendPinterestEmbedScript(outputHtmlString);
      }

      return outputHtmlString;
    }

    /**
     * Twitter の埋め込みスクリプトを追加した HTML 文字列を返します。
     *
     * @param {string} inputHtmlString - Twitter の埋め込みスクリプトを追加する、対象の HTML 文字列
     * @private
     */

  }, {
    key: '_appendTwitterTweetEmbedScript',
    value: function _appendTwitterTweetEmbedScript(inputHtmlString) {
      var outputHtmlString = inputHtmlString;
      var twitterTweetEmbedScriptDom = this._twitterTweetEmbedScripts[0];
      var twitterTweetEmbedScriptDomString = htmlparser.DomUtils.getInnerHTML({ children: [twitterTweetEmbedScriptDom] });

      outputHtmlString += DOM_SEPERATOR;
      outputHtmlString += twitterTweetEmbedScriptDomString;

      return outputHtmlString;
    }

    /**
     * Facebook の埋め込みスクリプトを追加した HTML 文字列を返します。
     *
     * @param {string} inputHtmlString - Facebook の埋め込みスクリプトを追加する、対象の HTML 文字列
     * @private
     */

  }, {
    key: '_appendFacebookPostEmbedScript',
    value: function _appendFacebookPostEmbedScript(inputHtmlString) {
      var outputHtmlString = inputHtmlString;
      var facebookPostEmbedScriptDom = _.find(this._facebookPostEmbedScripts, function (dom) {
        return dom.type === 'script';
      });
      var facebookPostEmbedScriptDomString = '\n      <div id="fb-root"></div>\n      ' + htmlparser.DomUtils.getInnerHTML({ children: [facebookPostEmbedScriptDom] }) + '\n    ';

      outputHtmlString = facebookPostEmbedScriptDomString + DOM_SEPERATOR + inputHtmlString;

      return outputHtmlString;
    }

    /**
     * Instagram の埋め込みスクリプトを追加した HTML 文字列を返します。
     *
     * @param {string} inputHtmlString - Instagram の埋め込みスクリプトを追加する、対象の HTML 文字列
     * @private
     */

  }, {
    key: '_appendInstagramEmbedScript',
    value: function _appendInstagramEmbedScript(inputHtmlString) {
      var outputHtmlString = inputHtmlString;
      var instagramEmbedScriptDom = this._instagramEmbedScripts[0];
      var instagramEmbedScriptDomString = htmlparser.DomUtils.getInnerHTML({ children: [instagramEmbedScriptDom] });

      outputHtmlString += DOM_SEPERATOR;
      outputHtmlString += instagramEmbedScriptDomString;

      return outputHtmlString;
    }

    /**
     * Pinterest の埋め込みスクリプトを追加した HTML 文字列を返します。
     *
     * @param {string} inputHtmlString - Pinterest の埋め込みスクリプトを追加する、対象の HTML 文字列
     * @private
     */

  }, {
    key: '_appendPinterestEmbedScript',
    value: function _appendPinterestEmbedScript(inputHtmlString) {
      var outputHtmlString = inputHtmlString;
      var pinterestEmbedScriptDom = this._pinterestEmbedScripts[0];
      var pinterestEmbedScriptDomString = htmlparser.DomUtils.getInnerHTML({ children: [pinterestEmbedScriptDom] });

      outputHtmlString += DOM_SEPERATOR;
      outputHtmlString += pinterestEmbedScriptDomString;

      return outputHtmlString;
    }

    /**
     * 記事本文の分析で見つかった警告を追加します。
     *
     * @param {string} message - 警告メッセージ
     * @private
     */

  }, {
    key: '_addWarning',
    value: function _addWarning(message) {
      if (_.indexOf(this._warnings, message) < 0) {
        this._warnings.push(message);
      }
    }
  }, {
    key: 'images',
    get: function get() {
      return this._images;
    }

    /**
     * 記事本文に含まれている、全ての画像キャプション DOM 要素の配列（htmlparser2 の DOM オブジェクト）
     *
     * @type {Array.<Object>}
     */

  }, {
    key: 'imageCaptions',
    get: function get() {
      return this._imageCaptions;
    }

    /**
     * 記事本文に含まれている、全ての動画 DOM 要素の配列（htmlparser2 の DOM オブジェクト）
     *
     * @type {Array.<Object>}
     */

  }, {
    key: 'videos',
    get: function get() {
      return this._videos;
    }

    /**
     * 記事本文に含まれている、全ての動画ソース DOM 要素の配列（htmlparser2 の DOM オブジェクト）
     *
     * @type {Array.<Object>}
     */

  }, {
    key: 'videoSources',
    get: function get() {
      var videoSources = [];

      _.each(this._videos, function (videoDom) {
        videoSources = _.concat(videoSources, domHelper.findChildDomsByTag(videoDom, 'source'));
      });

      return videoSources;
    }

    /**
     * 記事本文に含まれている、全ての動画キャプション DOM 要素の配列（htmlparser2 の DOM オブジェクト）
     *
     * @type {Array.<Object>}
     */

  }, {
    key: 'videoCaptions',
    get: function get() {
      return this._videoCaptions;
    }

    /**
     * 記事本文に含まれている、全ての Youtube 埋め込みタグのソース (url) の配列
     */

  }, {
    key: 'youtubeUrls',
    get: function get() {
      var youtubeUrls = [];

      _.each(this._youTubeEmbeds, function (youtubeEmbed) {
        youtubeUrls = _.concat(youtubeUrls, youtubeEmbed.attribs.src);
      });

      return youtubeUrls;
    }

    /**
     * 記事本文の分析で見つかった警告（警告メッセージの配列）
     *
     * @type {Array.<string>}
     */

  }, {
    key: 'warnings',
    get: function get() {
      return this._warnings;
    }

    /**
     * 広告記事（スポコン）かどうか
     *
     * @type {boolean}
     */

  }, {
    key: 'isSponsoredArticle',
    get: function get() {
      return this._isSponsoredArticle;
    },
    set: function set(value) {
      this._isSponsoredArticle = value;
    }
  }]);

  return TrillDescription;
}(EventEmitter);

//--------------------------------------
//  Class enumerations
//--------------------------------------

/**
 * 記事本文の HTML 出力タイプ
 * @enum {string}
 */


TrillDescription.HtmlOutputType = {
  /**
   * TRILL フィード仕様の記事本文
   */
  TRILL_FEED: 'trillFeed',

  /**
   * TRILL Web 記事詳細画面に表示するの記事本文
   */
  WEB_PART: 'webPart',

  /**
   * TRILL iOS / Android 記事詳細画面（WebView）や TRILL Admin 記事プレビュー画面に表示する記事本文
   */
  FULL_PAGE: 'fullPage',

  /**
   * TRILL Admin 記事本文エディター（TinyMCE）で表示・編集できる記事本文
   */
  TINY_MCE: 'tinyMce'
};

module.exports = TrillDescription;
